export default class Builder {
    constructor() {
        this.instances = [];
    }

    static globalInstances = new Map();

    static async initGlobals() {
        const globalModules = import.meta.glob('../../../components/**/*-script-global.js', { eager: true });
        for (const [path, module] of Object.entries(globalModules)) {
            if (Builder.globalInstances.has(path)) continue;

            try {
                const Component = module.default;

                if (typeof Component === 'function') {
                    const instance = new Component();
                    Builder.globalInstances.set(path, instance);
                }
            } catch (error) {
                console.error(`Error loading global component: ${path}`, error);
            }
        }
    }

    async init() {
        const modules = import.meta.glob('../../../components/**/*-script.js');
        const singleModules = import.meta.glob('../../../components/**/*-script-single.js');
        const sectionElements = document.querySelectorAll('#container > section[data-component]');

        for (const el of sectionElements) {
            if (el.dataset.initialized === 'true') continue;

            const componentName = el.dataset.component;

            const matchingSinglePath = Object.keys(singleModules).find(path =>
                path.endsWith(`/${componentName}/${componentName}-script-single.js`)
            );

            const matchingPath = matchingSinglePath || Object.keys(modules).find(path =>
                path.endsWith(`/${componentName}/${componentName}-script.js`)
            );

            if (matchingPath) {
                try {
                    const module = matchingSinglePath
                        ? await singleModules[matchingSinglePath]()
                        : await modules[matchingPath]();

                    const Component = module.default;

                    if (typeof Component === 'function') {
                        const instance = new Component(el);
                        this.instances.push(instance);
                        el.dataset.initialized = 'true';
                    }
                } catch (error) {
                    console.error(`Error loading ${componentName}:`, error);
                }
            }
            // sekcja bez pliku {name}-script.js jest poprawna (czysty HTML/CSS) — brak ostrzeżenia w konsoli
        }
    }

    destroy() {
        this.instances.forEach(inst => {
            if (inst && typeof inst.destroy === 'function') {
                inst.destroy();
            }
        });
        this.instances = [];

        document.querySelectorAll('[data-initialized]').forEach(el => {
            el.removeAttribute('data-initialized');
        });
    }
}